(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("hierarchy-model", [], factory);
	else if(typeof exports === 'object')
		exports["hierarchy-model"] = factory();
	else
		root["hierarchy-model"] = factory();
})(this, function() {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition